import { Card, Flex } from "antd";
import RecruitedSubjectIcon from "@/assets/icons/recruited_subject.svg?react";
import ActiveSubjectIcon from "@/assets/icons/active_subject.svg?react";
import CompletedSubjectIcon from "@/assets/icons/completed_subject.svg?react";
import TerminatedSubjectIcon from "@/assets/icons/terminated_subject.svg?react";
import InfoTooltip from "@/components/UI/InfoTooltip";
import { useFetch } from "@/hooks/FetchHook";
import Loader from "@/components/UI/Loader";
export const OverviewCards = () => {
  const { data: cardsData, isLoading } = useFetch({
    endpointSuffix: `activities/overview/cards/`,
  });

  const overviewCards = [
    {
      label: "Recruited subject count",
      statsLabel: (cardsData as any)?.totalRecruitedSubjects,
      statsUnits: "sbjs",
      valueTestId: "overview-card-value-recruited-subjects",
      cardIcon: <RecruitedSubjectIcon style={{ color: "#387853" }} />,
      tooltip:
        "Number of subjects who are, or have been, enrolled in the study, including: active, completed and early terminated.",
    },
    {
      label: "Active subject count",
      statsLabel: (cardsData as any)?.totalActiveSubjects,
      statsUnits: "sbjs",
      valueTestId: "overview-card-value-active-subjects",
      cardIcon: <ActiveSubjectIcon />,
      tooltip:
        "Number of subjects who are enrolled in the study, and who have not completed or discontinued the study.",
    },
    {
      label: "Completed subject count",
      statsLabel: (cardsData as any)?.totalCompleteSubjects,
      statsUnits: "sbjs",
      valueTestId: "overview-card-value-complete-subjects",
      cardIcon: <CompletedSubjectIcon />,
      tooltip:
        "Number of subjects who have completed the study, and who did not terminate early.",
    },
    {
      label: "Terminated subject count",
      statsLabel: (cardsData as any)?.totalTerminatedSubjects,
      statsUnits: "sbjs",
      valueTestId: "overview-card-value-terminated-subjects",
      cardIcon: <TerminatedSubjectIcon />,
      tooltip:
        "Number of subjects who had enrolled in the study, but had discontinued the study prior to completion.",
    },
  ];

  if (isLoading) {
    return (
      <div className="flex justify-center items-center">
        <Loader noMargin />
      </div>
    );
  }

  return (
    <Flex justify="space-between" gap={8} className="w-full">
      {overviewCards.map((card, index) => {
        // A metric is "available" when the backend sent a numeric value. It
        // returns null when the metric can't be computed for this
        // client/schema (e.g. no participant data, or no derived study status)
        // — show a dash instead of a misleading 0. A genuine 0 still renders.
        const hasValue =
          card.statsLabel !== null && card.statsLabel !== undefined;
        return (
          <Card
            className="overview-card mr-3 shadow-md w-full"
            data-testid={`overview-card-${index}`}
            key={index}
          >
            {card.cardIcon}
            <div className="flex mt-2">
              <p className="text-[14px] text-[#2B4752] font-semibold mr-[5px]">
                {card.label}
              </p>
              <InfoTooltip
                title={card.tooltip}
                data-testid={`tooltip-${index}`}
              />
            </div>
            <div className="flex items-center gap-2">
              <p
                className="text-[40px] font-semibold"
                data-testid={card.valueTestId}
              >
                {hasValue ? card.statsLabel : "—"}
              </p>
              {hasValue && (
                <p className="text-[20px] text-[#162429]">{card.statsUnits}</p>
              )}
            </div>
          </Card>
        );
      })}
    </Flex>
  );
};
